<template>
	<div id="rootVM" v-cloak>
		<div id="pageTitle">
			<b>CCTV 설치장소 변경(안전관리자용)</b>
		</div>
		<!-- Search -->
		<div class="panel panel-flat">
			<div class="panel-body" style="width: 1100px; margin: 0px 20px -20px auto; padding: 20px 0px">
				<form action="#" @submit.prevent="search">
					<div class="row">
						<div class="col-md-3" style="width: 300px; margin-left: 10px">
							<div class="form-group">
								<label>{{ detailsFieldMap.siteNm }}</label>
								<div class="select-wrapper">
									<select2 v-model="searchVM.siteNm" :disabled="isSiteDisabled">
										<option value="">전체</option>
										<option v-for="(row, index) in options.siteOptions" :key="index" :value="row.siteNm">{{ row.siteNm }}</option>
									</select2>
								</div>
							</div>
						</div>
						<!-- CCTV 설치장소 -->
						<div class="col-md-3" style="width: 300px; margin-right: 10px">
							<div class="form-group">
								<label>{{ detailsFieldMap.cctvInstallPlaceCont }}</label>
								<input
									type="text"
									id="startInput"
									class="form-control"
									:placeholder="detailsFieldMap.cctvInstallPlaceCont"
									v-model="searchVM.cctvInstallPlaceCont"
									:maxlength="maxLength.cctvInstallPlaceCont"
								/>
							</div>
						</div>
						<!-- 사용여부 -->
						<div class="col-md-3" style="width: 200px">
							<div class="form-group">
								<label>{{ detailsFieldMap.useYn }}</label>
								<select2 v-model="searchVM.useYn" :options="options.ynOptions">
									<option value="">전체</option>
								</select2>
							</div>
						</div>
						<!-- 검색 버튼 -->
						<div class="mb-10 text-right">
							<button type="submit" class="btn btn-labeled bg-primary">
								<b><i class="icon-search4"></i></b>
								검색
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<!-- Grid -->
		<div>
			<KendoGrid
				ref="grid"
				:auto-bind="true"
				:api-url="apiUrl.pageListApi"
				:columns="gridColumns"
				:apply-search-condition="applySearchStateOnGridLoad"
				@selected-row-item-changed="selectedRowItemChanged"
			></KendoGrid>

			<div class="mt-10 mb-15 text-right"></div>
		</div>

		<!-- Details -->
		<form id="detailsForm" action="#" class="form-horizontal form-validate-jquery" v-show="isEditMode">
			<div class="panel panel-flat">
				<div class="panel-heading">
					<h6 class="panel-title">
						<i class="icon-checkmark3 position-left"></i>
						<b>상세정보</b>
					</h6>
					<div class="heading-elements">
						<ul class="icons-list">
							<li><a @click="pannelHidden" data-action="collapse"></a></li>
						</ul>
					</div>
				</div>
				<div class="panel-body">
					<div class="row in-panel-body">
						<fieldset>
							<legend class="text-semibold">
								<i class="icon-cog3 position-left"></i>
								CCTV 정보
							</legend>
							<div class="col-lg-6 inputDiv1">
								<!-- CCTV ID, 수정모드만 표시 -->
								<jarvis-field
									:label="detailsFieldMap.cctvId"
									v-model="detailsItem.cctvId"
									required="true"
									v-if="isEditMode"
									disabled="true"
									field="detailsItem.cctvId"
									data-vv-name="detailsItem.cctvId"
									v-validate="validationRule.detailsItem.cctvId"
								></jarvis-field>
								<!-- CCTV 설치 장소 -->
								<jarvis-field
									id="firstInput"
									:label="detailsFieldMap.cctvInstallPlaceCont"
									field="detailsItem.cctvInstallPlaceCont"
									required="true"
									v-model="detailsItem.cctvInstallPlaceCont"
									v-validate="validationRule.detailsItem.cctvInstallPlaceCont"
									data-vv-name="detailsItem.cctvInstallPlaceCont"
									:maxLength="maxLength.cctvInstallPlaceCont"
								></jarvis-field>
								<!-- 사용여부 -->
								<jarvis-field :label="detailsFieldMap.useYn" field="detailsItem.useYn" required="true">
									<select2
										v-model="detailsItem.useYn"
										data-vv-name="detailsItem.useYn"
										v-validate="validationRule.detailsItem.useYn"
										:options="options.ynOptions"
									>
										<option value="">선택</option>
									</select2>
								</jarvis-field>
								<div v-show="isEditMode">
									<!-- 등록일, 수정모드만 표시 -->
									<jarvis-field
										:label="detailsFieldMap.regDtm"
										disabled="true"
										v-show="isEditMode"
										field="detailsItem.regDtm"
										:value="detailsItem.regDtm | toDisplayDateTime"
									></jarvis-field>
									<!-- 등록자, 수정모드만 표시 -->
									<jarvis-field
										:label="detailsFieldMap.regUser"
										disabled="true"
										v-show="isEditMode"
										field="detailsItem.regUser"
										:value="detailsItem.regUser"
									></jarvis-field>
									<!-- 수정일, 수정모드만 표시 -->
									<jarvis-field
										:label="detailsFieldMap.updDtm"
										disabled="true"
										v-show="isEditMode"
										field="detailsItem.updDtm"
										:value="detailsItem.updDtm | toDisplayDateTime"
									></jarvis-field>
									<!-- 수정자, 수정모드만 표시 -->
									<jarvis-field
										:label="detailsFieldMap.updUser"
										disabled="true"
										v-show="isEditMode"
										field="detailsItem.updUser"
										:value="detailsItem.updUser"
									></jarvis-field>
								</div>
							</div>
							<!-- 안전대상물 표시(안전대상물판별여부) -->
							<div class="col-lg-6" style="display: flex; flex-direction: column">
								<div class="col-lg-offset-1" style="border: 1px solid #ddd; padding-top: 40px; margin-bottom: 35px; padding-right: 10px">
									<div>
										<i
											style="color: gray; position: absolute; top: 20px"
											class="icon-question4"
											@mouseover="info($event)"
											@mouseleave="closeInfo($event)"
										></i>
										<span class="tooltipText">
											안전대상물 표시
											<br />
											*사용: 대상물이 안전한 상태인 경우에도 표시합니다.
											<br />
											*미사용: 대상물이 안전한 상태인 경우에는 표시하지 않습니다.
											<br />
											<br />
											대상물명표시
											<br />
											*사용: 판별된 대상의 대상물명과 조치대상명을 표시합니다.
											<br />
											*미사용: 판별된 대상의 조치대상명만 표시합니다.
										</span>
										<div>
											<jarvis-field :label="detailsFieldMap.safeObjectDistigshYn" field="detailsItem.safeObjectDistigshYn" required="true">
												<select2
													v-model="detailsItem.safeObjectDistigshYn"
													:required="true"
													data-vv-name="detailsItem.safeObjectDistigshYn"
													v-validate="validationRule.detailsItem.safeObjectDistigshYn"
													:options="options.ynOptions"
												>
													<option value="">선택</option>
												</select2>
											</jarvis-field>
										</div>
									</div>
									<!-- 대상물명표시(대상물명표시여부) -->
									<div>
										<div>
											<jarvis-field :label="detailsFieldMap.objectNmDisplayYn" field="detailsItem.objectNmDisplayYn" required="true">
												<select2
													v-model="detailsItem.objectNmDisplayYn"
													:required="true"
													data-vv-name="detailsItem.objectNmDisplayYn"
													v-validate="validationRule.detailsItem.objectNmDisplayYn"
													:options="options.ynOptions"
												>
													<option value="">선택</option>
												</select2>
											</jarvis-field>
										</div>
									</div>
								</div>
							</div>
						</fieldset>
					</div>
					<div>
						<div class="text-right" v-if="isEditMode">
							<button type="button" class="btn btn-labeled mx-sm-1" @click="closeDetails">
								<b><i class="icon-cross"></i></b>
								닫기
							</button>
							<button type="button" class="btn btn-labeled bg-primary" @click="updateData">
								<b><i class="icon-checkmark3"></i></b>
								저장
							</button>
						</div>
					</div>

					<span v-if="debug">
						isEditMode: {{ isEditMode }}
						<br />
						detailsItemOriginal: {{ detailsItemOriginal }}
						<br />
						detailsItem: {{ detailsItem }}
						<br />
						errors: {{ errors }}
						<br />
					</span>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import KendoGrid from '@/components/KendoGrid';
import Select2 from '@/components/Select2';
import _ from 'lodash';
import JarvisField from '@/components/JarvisField';
import apiIndex from '../../api/index';

let axiosExtention;
const cctvApi = apiIndex.cctv;

//상세필드검증규칙
const detailsValidationRule = {
	common: {
		//공통
		cctvId: 'max:10|required',
		siteId: 'max:10|required',
		useYn: 'required',
		installDtm: 'required',
		cctvInstallPlaceCont: 'max:500|required',
		safeObjectDistigshYn: 'required',
		objectNmDisplayYn: 'required',
	},
	edit: {
		//수정
	},
};

const maxLength = {
	cctvId: '10',
	siteId: '10',
	cctvInstallPlaceCont: '500',
};
_.extend(detailsValidationRule.edit, detailsValidationRule.common);

export default {
	components: {
		Select2: Select2,
		'jarvis-field': JarvisField,
		KendoGrid: KendoGrid,
	},
	created() {
		this.pageParam = JSON.parse(sessionStorage.getItem('cctvBySafeManagerPageParam'));
		if (!this.pageParam) location.href = apiIndex.mainUrl;
		if (this.pageParam.loginUserRolecd !== '00') {
			this.isSiteDisabled = true;
		}

		// 기존 라이브러리를 사용하기 위해 변환
		this.pageParam.ynOptions.forEach(e => {
			e.text = e.cdNm;
			e.value = e.cd;
		});

		//기본 현장 세팅
		this.searchVM.siteNm = this.pageParam.siteOptions.filter(e => e.siteId == this.pageParam.loginUserSiteId)[0].siteNm;
		this.pageParam.siteOptions.forEach(e => {
			e.text = e.siteNm;
			e.value = e.siteId;
		});
		this.options = {
			ynOptions: this.pageParam.ynOptions,
			siteOptions: this.pageParam.siteOptions,
		};
		this.gridColumns.filter(item => item.field == 'safeObjectDistigshYn')[0].mapData = this.options.ynOptions;
		this.gridColumns.filter(item => item.field == 'objectNmDisplayYn')[0].mapData = this.options.ynOptions;
		this.gridColumns.filter(item => item.field == 'useYn')[0].mapData = this.options.ynOptions;

		this.$validator.localize('ko', { attributes: this.$jarvisExtention.addKeyPrefix(this.detailsFieldMap, 'detailsItem.') });

		axiosExtention = this.$jarvisExtention.axiosExtention;
		this.search();
	},
	mounted() {},
	data: () => ({
		pageParam: null,
		//API목록
		apiUrl: {
			pageListApi: cctvApi.inqCctv,
			detailApi: cctvApi.inqOneCctv,
			excelApi: cctvApi.exlCctv,
			updApi: cctvApi.updCctv,
		},
		//검색VM
		searchVM: {
			siteNm: null,
			cctvInstallPlaceCont: null,
			useYn: '1', // 사용
		},
		options: {},
		searchState: {}, //적용된 검색조건
		//그리드설정
		gridColumns: [
			{ field: 'siteNm', title: '현장명', width: '20%' },
			{
				field: 'cctvInstallPlaceContOne',
				title: 'CCTV 설치 장소',
				width: '23%',
				align: 'center',
			},
			{
				field: 'safeObjectDistigshYn',
				title: '안전대상물표시',
				width: '20%',
				align: 'center',
				dataFormat: 'optionMap',
			},
			{
				field: 'objectNmDisplayYn',
				title: '대상물명표시',
				width: '20%',
				align: 'center',
				dataFormat: 'optionMap',
			},
			{
				field: 'useYn',
				title: '사용여부',
				width: '5%',
				align: 'center',
				dataFormat: 'optionMap',
			},
			{
				field: 'regDtm',
				title: '등록일',
				width: '6%',
				align: 'center',
				dataFormat: 'YYYY-MM-DD',
			},
			{
				field: 'updDtm',
				title: '수정일',
				width: '6%',
				align: 'center',
				dataFormat: 'YYYY-MM-DD',
			},
		],
		//상세필드명맵
		detailsFieldMap: {
			cctvId: 'CCTV ID',
			siteNm: '현장명',
			cctvInstallPlaceCont: 'CCTV 설치 장소',
			safeObjectDistigshYn: '안전대상물표시',
			objectNmDisplayYn: '대상물명표시',
			useYn: '사용 여부',
			regDtm: '등록일',
			regUser: '등록자',
			updDtm: '수정일',
			updUser: '수정자',
		},
		//인풋 최댓값 설정
		maxLength,
		detailsItemOriginal: {}, //상세편집 원본
		detailsItem: {}, //상세편집 수정본
		errorInstallDtm: '',
		debug: false,
		isSiteDisabled: false,
	}),
	computed: {
		isEditMode() {
			return !_.isEmpty(this.detailsItem) && !_.isEmpty(this.detailsItemOriginal);
		},
		validationRule() {
			var rule = {};
			if (this.isEditMode) {
				rule = detailsValidationRule.edit;
			}
			return { detailsItem: rule };
		},
	},
	watch: {
		detailsItem(newVal) {
			this.$validator.reset(); //Validation상태 초기화
			//details활성화 시 스크롤 이동처리
			if (!_.isEmpty(newVal)) {
				this.$nextTick(function () {
					window.scrollTo({ top: this.getDetailsFormPositionForScrolling(), behavior: 'smooth' });
				});
			}
		},
	},
	methods: {
		getDetailsFormPositionForScrolling() {
			let element = document.getElementById('detailsForm');
			return element.getBoundingClientRect().top + window.scrollY;
		},
		// info tooltip 제거
		closeInfo(event) {
			let element = event.srcElement.nextElementSibling;
			element.style.visibility = 'hidden';
		},
		// info tooltip 생성
		info(event) {
			let element = event.srcElement.nextElementSibling;
			element.style.visibility = 'visible';
		},
		// 첫번째 인풋창에 포커스 두도록
		focusFirstInput(inputId) {
			document.getElementById(inputId).focus();
		},
		checkInstallDtmValue() {
			if (this.detailsItem.installDtm == null || this.detailsItem.installDtm == '') {
				this.errorInstallDtm = 'reqInstallDtd';
			} else {
				this.errorInstallDtm = '';
			}
		},
		pannelHidden(e) {
			// click event 에서 target pannel 가져오기
			let pannel = $(e.target).closest('.panel').find('.panel-body')[0];
			if (pannel) {
				if (pannel.style.display === 'none') {
					e.target.classList.remove('rotate-180');
					pannel.style.display = 'block';
				} else {
					e.target.classList.add('rotate-180');
					pannel.style.display = 'none';
				}
			}
		},
		//검색적용
		search() {
			this.searchState = $.extend(true /*deep*/, {}, this.searchVM);
			this.$nextTick(function () {
				this.loadGrid();
			});
		},
		//그리드로드
		loadGrid() {
			this.closeDetails();
			this.$refs.grid.load();
		},
		//그리드로드시 검색조건적용
		applySearchStateOnGridLoad(param) {
			return $.extend(true /*deep*/, param, this.searchState || {});
		},
		//그리드선택처리
		selectedRowItemChanged(selectedRowItem) {
			this.errorInstallDtm = '';
			if (!_.isEmpty(selectedRowItem)) {
				this.$axios
					.post(cctvApi.inqOneCctv, { cctvId: selectedRowItem.cctvId })
					.then(
						function (response) {
							this.detailsItemOriginal = $.extend(true, {}, response.data);
							this.detailsItem = $.extend(true, {}, response.data);
							this.detailsItem.installDtm = this.detailsItem.cctvInstallVO.installDtm;
							// this.detailsItem.cctvInstallPlaceCont = this.detailsItem.cctvInstallVO.cctvInstallPlaceCont;

							//data에서 미리 선언되어 있지 않은 변수에 값을 할당해 바인딩하기 위해 set해줌.
							this.$set(this.detailsItem, 'cctvInstallPlaceCont', this.detailsItem.cctvInstallVO.cctvInstallPlaceCont);
							setTimeout(() => this.focusFirstInput('firstInput'), 500);
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			} else {
				//상세화면 닫기 (다시로드등으로 선택변경)
				this.closeDetails();
			}
		},
		//상세화면 닫기
		closeDetails() {
			this.detailsItemOriginal = {};
			this.detailsItem = {};
		},
		//수정저장
		updateData() {
			this.$validator.validateAll().then(success => {
				if (success === false) {
					return;
				}
				if (this.detailsItem.installDtm == null || this.detailsItem.installDtm == '') {
					return;
				}
				this.detailsItem.cctvInstallVO.installDtm = this.detailsItem.installDtm;
				this.detailsItem.cctvInstallVO.cctvInstallPlaceCont = this.detailsItem.cctvInstallPlaceCont;

				if (confirm('수정한 데이터를 저장하시겠습니까?')) {
					this.$axios
						.post(this.apiUrl.updApi, this.detailsItem)
						.then(
							function (r) {
								r;
								this.loadGrid();
							}.bind(this),
						)
						.catch(axiosExtention.buildErrorHandler(this.detailsFieldMap));
				}
			});
		},
	},
};
</script>

<style scoped>
.select-wrapper {
	min-width: 190px !important;
	width: 190px !important;
}
.tooltipText {
	width: 360px;
	background-color: gray;
	color: #fff;
	text-align: center;
	border-radius: 6px;
	padding: 5px 0;
	position: absolute;
	top: 40px;
	z-index: 1;
	visibility: hidden;
}

[v-cloak] > * {
	display: none !important;
}

#rootVM > .panel .panel-body .form-group {
	display: flex;
	align-items: center;
}
#rootVM > .panel .panel-body .form-group label {
	width: 60%;
	margin-top: 5px;
	max-width: 130px;
}

.table th {
	background: #eee;
	vertical-align: middle !important;
	font-weight: bold;
}
.panel-body .table th:first-child {
	width: 120px;
	text-align: center;
}

.table td {
	vertical-align: middle;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 1px;
}

.panel-body {
	text-align: center;
}

.panel-body .table td:first-child {
	text-align: center;
}
.panel-body .table td:last-child {
	text-align: center;
	width: 80px;
}

.in-panel-body {
	display: inline-block;
	width: 1200px;
}

.table [empty] {
	display: none;
}
.table [empty] td {
	padding: 30px;
	font-size: 1.2em;
	text-align: center;
}
.table [empty]:first-child:last-child {
	display: table-row;
}

.itemWrapper > label {
	margin-top: 7px;
}

.itemWrapper.reqInstallDtd .msg:before {
	content: '\ed63';
	font-family: 'icomoon';
	font-size: 16px;
	position: absolute;
	top: 4.3vh;
	left: 0.7vw;
}

.itemWrapper.reqInstallDtd > div > input {
	border: 1px solid #d84315;
}

.required,
.itemWrapper.reqInstallDtd > label {
	color: #d84315;
}
.itemWrapper.reqInstallDtd > div .msg {
	margin-top: 7px;
	color: #f44336;
	display: block;
}
.itemWrapper.reqInstallDtd .msg:after {
	margin-left: 1rem;
	content: '설치일시는 필수 정보입니다.';
}
</style>
